import React, { Component, PropTypes } from 'react'
import { render } from 'react-dom'
import createHistory from 'history/lib/createBrowserHistory'

import { createStore } from 'redux'
import { connect, Provider } from 'react-redux'

import CategoryFilter from './react_components/CategoryFilter'
import ArticleList from './react_components/PresseList'

import { pathFromfilters, filtersFromPath } from './utils/CategoryFilterRouting'
import { postFilter, prepPosts } from './utils/CategoryFilterPostFunctions'

import { Normal } from './react_components/teasers'

const HISTORY = createHistory()
const ALL_POSTS = prepPosts({ posts: apr_data.posts, taxonomies: apr_data.taxonomies})

const initialState = {
	filters: Object.create(null),
	posts: ALL_POSTS,
}

const STORE = createStore((state = initialState, {type, ...action}) => {

	switch (type) {
		case 'TOGGLE_FILTER':

			{
				// Block scoped
				const { taxonomy, termId } = action
				const filters = Object.assign({}, state.filters)

				if (termId === filters[taxonomy]) {
					delete filters[taxonomy]
				} else {
					filters[taxonomy] = termId
				}

				HISTORY.push({
					pathname: pathFromfilters(document.location.pathname, filters),
					state: { filters },
				})

				return Object.assign({}, state, {
					filters,
					posts: ALL_POSTS.filter(postFilter.bind(null, filters))
				})
			}

		case 'SET_FILTERS':
			{
				return Object.assign({}, state, {
					filters: action.filters,
					posts: ALL_POSTS.filter(postFilter.bind(null, action.filters))
				})
			}

		default:
			return state
	}
})

class App extends Component {
	constructor(props) {
		super(props)
		this.zoomBlock = null
		this.unlisten = () => null
	}

	componentWillMount() {

		// block scope
		{
			let zb
			let reactZb
			if (zb = document.getElementById('jsCategoryZoomSur')) {
				reactZb = zb.cloneNode(true)
				this.zoomBlock = <a
					href={ reactZb.href }
					className={ reactZb.className }
					dangerouslySetInnerHTML={{ __html: reactZb.innerHTML }}
				/>
			}
		}
	}

	componentDidMount() {

		this.unlisten = HISTORY.listen(({ action, search, hash, ...rest }) => {

			switch (action) {
				case 'POP':
					{
						if (!hash || hash === '#/') {

							STORE.dispatch({
								type: 'SET_FILTERS',
								filters: Object.create(null),
							})

						} else {

							if (hash[0] === '#' && hash[1] === '/') {
								STORE.dispatch({
									type: 'SET_FILTERS',
									filters: filtersFromPath(hash.substr(2)),
								})
							}

						}
					}
					break
			}
		})

	}

	componentWillUnmount() {
		this.unlisten()
	}

	render() {
		const zoomBlockDisplay = Object.keys(this.props.filters).every( i => !this.props.filters[i])
			? null   // remove prop
			: 'none' // set display: none

		return <div>
			<h1 className="header-tag__hidden">{ this.props.sectionTitle }</h1>
			<div className="category__header">
				<div className="container">

					<CategoryFilter
						className='category-filters'
						filter1={{
							label: 'Risques :',
							key: 'interest',
						}}
						filter2={{
							label: 'Profil :',
							key: 'profil',
						}}
					/>

					<div style={{ display: zoomBlockDisplay }}>
						{ this.zoomBlock }
					</div>

				</div>
			</div>

			<div className="container bg-white">
				<div className="category__article-list">
					{ React.createElement(connect(({ posts }) => ({ posts }))(ArticleList), {
						defaultType: Normal,
					})}
				</div>
			</div>
		</div>
	}
}

App.propTypes = {
	sectionTitle: PropTypes.string.isRequired,
}

render(
	<Provider store={ STORE }>
		{ React.createElement(connect(state => state)(App), {
			sectionTitle: apr_data.sectionTitle,
		}) }
	</Provider>,
	document.getElementById('jsCategoryApp')
)
/* eslint no-cond-assign:0 */



// WEBPACK FOOTER //
// ./js/website/category-informe.js